<template>
    <base-graphic
        :group-icon="groupIcon"
        :title-text="titleText"
        :subtitle-text="subtitleText"
        :loading="loading"
        :hire-resource="hireResource"
        :hire-resource-link="hireResourceLink"
        :tooltip-link="tooltipLink"
        :tooltip-text="tooltipText"
        :error="error"
        :no-data-message="noDataMessage"
    >
        <template #action-title>
            <slot name="action-title" />
        </template>

        <template #action-header>
            <slot name="action-header" />
        </template>

        <template #graphic-data>
            <div v-show="!loading && !error" class="container-funnel-graphic">
                <section class="funnel-graphic">
                    <div
                        v-for="(step, index) in dataset"
                        :key="index"
                        class="funnel"
                    >
                        <span
                            v-if="step.day && isMobile"
                            class="text-day"
                        >
                            {{ step.day }}
                        </span>

                        <span class="step-value">{{ step.value }}</span>

                        <span v-if="isMobile" class="text">{{ step.label }}</span>
                    </div>
                </section>

                <section v-if="!isMobile" class="funnel-text">
                    <div
                        v-for="(step, index) in dataset"
                        :key="index"
                        class="container-text"
                    >
                        <span class="text">{{ step.label }}</span>

                        <span
                            v-if="step.day && !isMobile"
                            class="text-day"
                        >
                            {{ step.day }}
                        </span>
                    </div>
                </section>

                <section class="funnel-percent-value">
                    <div
                        v-for="(percent, index) in dataPercent"
                        :key="index"
                        class="percent-value"
                    >
                        <div class="container-arrow">
                            <svg v-if="!isMobile" width="8" height="35" viewBox="0 0 8 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.57012 4.47669L4.11443 4.68248L4.57012 4.47669ZM5.10041 28.749L4.63617 28.5633L5.10041 28.749ZM2.54043 34.197C2.64921 34.4508 2.94314 34.5684 3.19696 34.4596L7.33311 32.6869C7.58693 32.5782 7.7045 32.2842 7.59573 32.0304C7.48695 31.7766 7.19301 31.659 6.93919 31.7678L3.26261 33.3435L1.68694 29.6669C1.57816 29.4131 1.28422 29.2955 1.0304 29.4043C0.776588 29.5131 0.659013 29.807 0.767791 30.0608L2.54043 34.197ZM2.54431 1.20579L4.11443 4.68248L5.0258 4.27089L3.45569 0.794207L2.54431 1.20579ZM4.63617 28.5633L2.53576 33.8143L3.46424 34.1857L5.56464 28.9347L4.63617 28.5633ZM4.11443 4.68248C7.52785 12.2408 7.71623 20.8631 4.63617 28.5633L5.56464 28.9347C8.74569 20.9821 8.55113 12.077 5.0258 4.27089L4.11443 4.68248Z" fill="#667181"/>
                            </svg>

                            <svg v-if="isMobile" width="16" height="37" viewBox="0 0 16 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.80292 33.2308L1.93637 33.7127L1.80292 33.2308ZM0.564967 33.2068C0.428904 33.4471 0.513396 33.7522 0.753693 33.8882L4.66951 36.1055C4.9098 36.2416 5.2149 36.1571 5.35096 35.9168C5.48703 35.6765 5.40253 35.3714 5.16224 35.2354L1.68151 33.2644L3.65244 29.7837C3.78851 29.5434 3.70401 29.2383 3.46372 29.1022C3.22343 28.9662 2.91833 29.0507 2.78226 29.291L0.564967 33.2068ZM1.66948 32.7489L0.866608 32.9713L1.13351 33.935L1.93637 33.7127L1.66948 32.7489ZM6.70508 1.41579C19.1259 9.71193 16.0643 28.7624 1.66948 32.7489L1.93637 33.7127C17.156 29.4977 20.393 9.35571 7.26051 0.584218L6.70508 1.41579Z" fill="#667181"/>
                            </svg>
                        </div>

                        <div class="percent">
                            {{ percent.percent }}
                        </div>
                    </div>
                </section>
            </div>
        </template>
    </base-graphic>
</template>

<script>
    import baseGraphic from '../base-graphic'

    export default {
        name: 'funnel-graphic',

        components: {
            baseGraphic
        },

        props: {
			/**
			 * Utilize para adicionar um icone no grafico
			 */
			groupIcon: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Utilize para adicionar um titulo ao grafico
			 */
			titleText: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Utilize para adicionar um subtitle ao grafico
			 */
			subtitleText: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Utilize para adicionar dados ao grafico
			 */
            dataset: {
                type: [Array, Object],
                required: false,
                default: () => []
            },
			/**
			 * Utilize para adicionar dados de porcentagem ao grafico
			 */
            dataPercent: {
                type: [Array, Object],
                required: false,
                default: () => []
            },
			/**
			 * Utilize para adicionar um loading a tela
			 */
			loading: {
				type: Boolean,
				required: false,
				default: false
			},
			/**
			 * Utilize para adicionar uma ancora para contratar o recurso
			 */
			hireResource: {
				type: Boolean,
				required: false,
				default: false
			},
			/**
			 * Link para a tela com as informações para a contratação do recurso
			 */
			hireResourceLink: {
				type: String,
				required: false,
				default: '#'
			},
			/**
			 * Utilize para adicionar um link ao tooltip
			 */
			tooltipLink: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Mensagem a ser mostrada no tooltip
			 */
			tooltipText: {
				type: String,
				required: false,
				default: 'O gráfico abaixo é atualizado em tempo real de acordo com a data de atualização.'
			},
			/**
			 * Mensagem a ser mostrada quando não houver informações ou ocorrer um erro ao
			 * buscar os dados
			 */
			noDataMessage: {
				type: String,
				required: false,
				default: 'Não há dados a serem exibidos'
			},
			/**
			 * Define se houve um erro ao trazer os dados
			 */
			error: {
				type: Boolean,
				required: false,
				default: false
			}
        },

        data() {
            return {
                windowWidth: window.innerWidth
            };
        },

        computed: {
            isMobile() {
                return this.windowWidth <= 767 // Por exemplo, consideramos abaixo de 768px como mobile
            }
        },

        created() {
            window.addEventListener('resize', this.handleResize)
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize)
        },
        methods: {
            handleResize() {
                this.windowWidth = window.innerWidth
            }
        }
    }
</script>

<style lang="stylus" scoped>
	@import 'styles.styl';
</style>
